import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import AppRoutes from "./routes/AppRoutes";
import { ThemeProvider } from "./context/ThemeContext";
import { UserConfigProvider } from "./context/UserConfigContext";
import { UnitProvider } from "./context/UnitContext";
import { AlertsProvider } from "./context/AlertsContext";
import { DeviceProvider } from "./context/DeviceContext";
import { SubscriptionProvider } from "./context/SubscriptionContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {/* El tema envuelve a todo: es la única capa que necesita estar resuelta
        antes de que se pinte cualquier pantalla, pública o privada. */}
    <ThemeProvider>
      {/* La suscripción envuelve a los dispositivos porque los límites del plan
          condicionan cuántos se pueden vincular, no al revés. */}
      <SubscriptionProvider>
        <DeviceProvider>
          <UnitProvider>
            <UserConfigProvider>
              <AlertsProvider>
                <AppRoutes />
              </AlertsProvider>
            </UserConfigProvider>
          </UnitProvider>
        </DeviceProvider>
      </SubscriptionProvider>
    </ThemeProvider>
  </React.StrictMode>
);
